import { render } from "./coach-detail-image.vue?vue&type=template&id=6fff566c"
import script from "./coach-detail-image.vue?vue&type=script&lang=js"
export * from "./coach-detail-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__